var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.52056 11.4156C6.57407 11.4933 6.64568 11.5569 6.72921 11.6008C6.81274 11.6447 6.90569 11.6676 7.00005 11.6676C7.09442 11.6676 7.18737 11.6447 7.2709 11.6008C7.35443 11.5569 7.42604 11.4933 7.47955 11.4156L12.7296 3.83224C12.7903 3.74478 12.826 3.64233 12.8326 3.53603C12.8392 3.42973 12.8166 3.32365 12.7672 3.22931C12.7177 3.13496 12.6434 3.05597 12.5522 3.00091C12.4611 2.94585 12.3566 2.91683 12.2501 2.91699H1.75005C1.6438 2.91743 1.53967 2.94683 1.44887 3.00202C1.35807 3.05721 1.28403 3.13612 1.23472 3.23024C1.18541 3.32436 1.16269 3.43015 1.169 3.53622C1.17532 3.64229 1.21043 3.74463 1.27055 3.83224L6.52056 11.4156Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.899620b35dc7a87d55d52c11e2acbf6d.svg";
export { ForwardRef as ReactComponent };